import React from "react";
import { FormValues } from "../../../forms";
import {
    replaceMergeTags,
    evaluateValues,
    replaceMergeTagsInString
} from "../../../forms/helper";

const connectValues = (
    args: { [key: string]: any },
    values: FormValues,
    replaceFunction: (template: string, values: FormValues) => any
) =>
    Object.entries(args).reduce(
        (r, [k, v]) => ({
            ...r,
            [k]: typeof v === "string" ? replaceFunction(v, values) : v
        }),
        {}
    );

const filterConnectedProps = (
    props: { [key: string]: any },
    connect: string[]
) =>
    Object.entries(props).reduce(
        (r, [k, v]) => (connect.includes(k) ? { ...r, [k]: v } : r),
        {}
    );

const buildComponentWithValues = (
    Component: React.ComponentType<any>,
    connect: string[],
    props: any,
    replaceFunction: (template: string, values: FormValues) => any
) => {
    const connected = connectValues(
        filterConnectedProps(props, connect),
        props.context ? props.context.getValues() : {},
        replaceFunction
    );
    return <Component {...{ ...props, ...connected }} />;
};

const withValues = (
    Component: React.ComponentType<any>,
    connect: string[]
) => (props: any) =>
    buildComponentWithValues(Component, connect, props, replaceMergeTags);

const withStringValues = (
    Component: React.ComponentType<any>,
    connect: string[]
) => (props: any) =>
    buildComponentWithValues(Component, connect, props, replaceMergeTagsInString);

const withExpression = (
    Component: React.ComponentType<any>,
    connect: string[]
) => (props: any) =>
    buildComponentWithValues(Component, connect, props, evaluateValues);

export { withValues, withStringValues, withExpression };
